import {
  ApplicationField,
  ApplicationFieldName,
} from '../application-definition/application-field';
import { FormFieldName } from './formFieldName';
import { ValueListItem } from '../valueListItem';

export class FormField {
  constructor(
    public fieldName: FormFieldName,
    public isRequired: boolean,
    public isHidden: boolean,
    public valueList: ValueListItem[]
  ) {}
}

const hasFields = (fields: any[]): boolean => !fields || fields.length !== 0;

export const getHiddenAndRequiredForApplicationField = (
  fields: ApplicationField[]
): {
  isRequired: Partial<Record<ApplicationFieldName, boolean>>;
  isHidden: Partial<Record<ApplicationFieldName, boolean>>;
} => {
  if (!hasFields(fields)) {
    return { isRequired: {}, isHidden: {} };
  }
  const isRequired: Partial<Record<ApplicationFieldName, boolean>> = {};
  const isHidden: Partial<Record<ApplicationFieldName, boolean>> = {};
  for (var field of fields) {
    if (field.isRequired) {
      isRequired[field.fieldName] = true;
    }
    if (!field.isVisible) {
      isHidden[field.fieldName] = true;
    }
  }
  return { isRequired, isHidden };
};

export const getHiddenAndRequired = (
  fields: FormField[]
): {
  isRequired: Partial<Record<FormFieldName, boolean>>;
  isHidden: Partial<Record<FormFieldName, boolean>>;
} => {
  if (!hasFields(fields)) {
    return { isRequired: {}, isHidden: {} };
  }

  const isRequired: Partial<Record<FormFieldName, boolean>> = {};
  const isHidden: Partial<Record<FormFieldName, boolean>> = {};
  for (var field of fields) {
    if (field.isRequired) {
      isRequired[field.fieldName] = true;
    }
    if (field.isHidden) {
      isHidden[field.fieldName] = true;
    }
  }
  return { isRequired, isHidden };
};

export const isMailingAddressVisible = (
  isHidden: Partial<Record<FormFieldName, boolean>>
): boolean =>
  !(
    isHidden.Address1 &&
    isHidden.City &&
    isHidden.PostalCode &&
    isHidden.StateOrProvince &&
    isHidden.Country
  );
